import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "projects-new",
  "use": "projects-new-usage",
  "viewBox": "0 0 149.3 108.4",
  "content": "<symbol viewBox=\"0 0 149.3 108.4\" id=\"projects-new\"><path d=\"M93.2 31.4c-.6-2.2-3.3-4-6.1-4H14.2c-2.8-.1-5.6 1.8-6.2 4l-1 6.1h87.2l-1-6.1zm5.1 11.2H3c-1.6 0-2.9 1.3-3 2.9v.3l4.7 59.1c.2 2 1.9 3.5 3.9 3.5h84.1c2 0 3.7-1.5 3.9-3.5l4.7-59.1c.2-1.6-1-3-2.6-3.2h-.4zM148 16.1h-14.8V1.3c0-.8-.6-1.3-1.3-1.3h-8c-.6 0-1.3.6-1.3 1.3v14.8h-14.8c-.8 0-1.3.6-1.3 1.3v8c0 .8.6 1.3 1.3 1.3h14.8v14.6c0 .8.6 1.3 1.3 1.3h8c.8 0 1.3-.6 1.3-1.3V26.5H148c.8 0 1.3-.6 1.3-1.3v-8c0-.6-.6-1.1-1.3-1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/projects-new.svg
// module id = e/Xc
// module chunks = 1